import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BookingCategory } from '../../booking/booking.models';
import { HttpParams, HttpClient } from '@angular/common/http';
import { environment } from '../../../../../../environments/environment';
import * as moment from 'moment';
import { PRODUCT_TYPE } from '../../booking/booking.constants';

@Component({
    selector     : 'fuse-ticket-add-form-dialog',
    templateUrl  : './ticket-add-form.component.html',
    styleUrls    : ['./ticket-add-form.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class TicketAddFormDialogComponent implements OnInit
{
    bookingDate: Date;
    productId: string;
    dialogTitle: string;
    eventForm: FormGroup;
    bookingCategory: BookingCategory;

    constructor(
        public dialogRef: MatDialogRef<TicketAddFormDialogComponent>,
        private http: HttpClient,
        @Inject(MAT_DIALOG_DATA) private data: any,
    ) {
        this.bookingDate = data.date;
        this.productId = data.product._id;

        this.dialogTitle = 'Nouveau billet';
        this.eventForm = this.createEventForm();

        this.getCategory(this.data.category._id, this.bookingDate).then((response) => {
            this.bookingCategory = response;
            if (data.type === PRODUCT_TYPE.CRUISE) {
                this.bookingCategory.products = this.bookingCategory.products.filter(product => product._id === this.productId);
            }
            // this.eventForm.setValue({productId: this.productId});
            this.eventForm.get('productId').setValue(this.productId);
        }).catch(() => this.dialogRef.close(this.eventForm));
    }

    ngOnInit() {}

    createEventForm() {
        return new FormGroup({
            bookingDate: new FormControl(this.bookingDate || '', [Validators.required]),
            productId: new FormControl('', [Validators.required]),
        });
    }

    getCategory(id: string, date: Date): Promise<any>
    {
        return new Promise((resolve, reject) => {
            if (typeof date === 'string') {
                date = new Date(date);
            }
            const params = new HttpParams().set('date', date.toString());

            this.http.get<BookingCategory>(`${environment.apiUrl}/booking/category/${id}`, {params}) // /${this.routeParams.id}
                .subscribe(response => {
                    resolve(response);
                }, reject);
        });
    }

    changeDate(event: any) {
        const date = new Date(event);
        this.bookingDate = this.toUTCSmallDate(date);
        this.getCategory(this.data.category._id, this.bookingDate).then((response) => {
            this.bookingCategory = response;
        }).catch(() => this.dialogRef.close(this.eventForm));
    }

    toUTCSmallDate(date?: any) {
        if (!date || typeof date === 'undefined') {
            date = new Date();
        }
        if (date instanceof moment) {
            date = (date as moment.Moment).toDate();
        }
        if (typeof date === 'string') {
            date = new Date(date);
        }
        return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0));
    }

}



// WEBPACK FOOTER //
// /usr/app/src/app/main/content/app/order/ticket-add-form/ticket-add-form.component.ts